import React, { useEffect, useRef } from "react";
import jsonData from "./Blogs.json";
import { useParams } from "react-router-dom";

function Blog() {
  const { section } = useParams();
  const blog = jsonData.find((item) => item.searchkey === section);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const observedElements = useRef([]);
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.transform = "scale(1)";
            entry.target.style.opacity = "1";
          } else {
            entry.target.style.transform = "scale(0.95)";
            entry.target.style.opacity = "0";
          }
        });
      },
      { threshold: 0.1 }
    );

    observedElements.current.forEach((el) => {
      if (el) {
        observer.observe(el);
      }
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const processContent = (content) => {
    const colonIndex = content.indexOf(":");
    if (colonIndex !== -1) {
      const beforeColon = content.substring(0, colonIndex + 1).trim();
      const afterColon = content.substring(colonIndex + 1).trim();
      const wordsCount = beforeColon.split(" ").length;

      if (wordsCount <= 5) {
        return (
          <>
            <strong>{beforeColon}</strong> {afterColon}
          </>
        );
      }
    }
    return content;
  };

  if (!blog) {
    return "NO BLOG FOUND";
  }
  return (
    <div className="One-Blog">
      <h1 ref={(el) => el && observedElements.current.push(el)}>
        {blog.title}
      </h1>
      <div>
        <p
          ref={(el) => el && observedElements.current.push(el)}
          className="lineP"
        >
          {blog.by}
        </p>
        <p
          ref={(el) => el && observedElements.current.push(el)}
          className="lineP"
        >
          {blog.Date}
        </p>
        <p ref={(el) => el && observedElements.current.push(el)}>{blog.tag}</p>
      </div>
      <img
        ref={(el) => el && observedElements.current.push(el)}
        src={blog.img}
        alt=""
      />
      {blog.content.map((item, index) => {
        if (item.tag === "img") {
          return (
            <img
              ref={(el) => el && observedElements.current.push(el)}
              key={index}
              src={item.src}
              alt=""
            />
          );
        } else if (item.tag === "h2") {
          return (
            <h2
              ref={(el) => el && observedElements.current.push(el)}
              key={index}
            >
              {item.text}
            </h2>
          );
        } else if (item.tag === "h1") {
          return (
            <h1
              ref={(el) => el && observedElements.current.push(el)}
              key={index}
            >
              {item.text}
            </h1>
          );
        } else if (item.tag === "p") {
          return (
            <p
              ref={(el) => el && observedElements.current.push(el)}
              key={index}
            >
              {processContent(item.text)}
            </p>
          );
        } else if (item.tag === "li") {
          return (
            <li
              ref={(el) => el && observedElements.current.push(el)}
              key={index}
            >
              {processContent(item.text)}
            </li>
          );
        } else {
          return null;
        }
      })}
    </div>
  );
}

export default Blog;
